/**
 * The header's way into Live alerts (CRATUS 2.0 #26, roadmap §10.5): the open alarms, counted,
 * one click from the dropdown that lists them, on any screen. Beside the bell, and a different
 * question: the bell is what HAPPENED while you watched; this is what is OPEN now.
 */
import type { ReactNode } from 'react';
import { Icon } from '@/components/lumen/Icon';
import { useAlarmSummary } from '@/lib/api/queries';

export function LiveAlertsButton({ open, onToggle }: { open: boolean; onToggle: () => void }): ReactNode {
  const summary = useAlarmSummary();
  const count = summary.data?.open ?? 0;
  const critical = summary.data?.bySeverity.critical ?? 0;
  const label = count === 0 ? 'Live alerts — nothing open' : `Live alerts — ${count} open${critical > 0 ? `, ${critical} critical` : ''}`;
  return (
    <button
      type="button"
      onClick={onToggle}
      aria-expanded={open}
      aria-haspopup="dialog"
      data-hd-trigger="live"
      aria-label={label}
      title={label}
      className="lm-hov relative flex items-center gap-[6px] rounded-[var(--radius-sm)] px-[8px]"
      style={{ height: 'var(--header-ctl-h)', color: count > 0 ? 'var(--fg)' : 'var(--muted-fg)' }}
    >
      <Icon name="ic-activity" size={15} />
      <span className="hidden text-[12px] font-semibold md:inline">Live</span>
      {count > 0 && (
        <span
          className="lm-num flex min-w-[17px] items-center justify-center rounded-[var(--radius-pill)] px-[4px] text-[10px] font-bold"
          style={{ background: critical > 0 ? 'var(--danger)' : 'var(--warn)', color: 'var(--primary-fg)' }}
        >
          {count > 99 ? '99+' : count}
        </span>
      )}
    </button>
  );
}
